import Lookup from 'src/componentes/select2';

const TipoOrganizacao = (props) => {
  return (
    <Lookup
      clearable={false}
      labelKey="descricao"
      valueKey="id"
      url="/TipoOrganizacaoLookup"
      {...props}
    />
  );
};

export default TipoOrganizacao;
